export interface AppointmentSlot {
  startDate: Date | null;
  endDate: Date | null;
  timeslotLabel: string;
  key: string; // useful for list component
  otherDate: boolean; // special slot
}

export interface AppointmentResponse {
  slots: AppointmentSlot[]
}

export interface AppointmentInfo {
  remarks: string | null;
  selectedSlot: AppointmentSlot | null;
  noSatisfyingDate: boolean;
}

export const appointmentSearchInterval = 28
